import { gql } from "@outschool/ui-apollo";

export const MARK_THREAD_AS_READ_MUTATION = gql`
  mutation MarkThreadAsRead($threadUid: ID!) {
    markPrivateClassMessageThreadAsRead(threadUid: $threadUid)
  }
`;
